import { customAxios, customFileAxios, customPatchAxios } from "./customAxios";

/**
 * 설비구역 상세
 * @param {*} id 
 * @returns 
 */
export const getEquipmentZonesById = async(id)=>{
  const res = await customAxios.get('/api/equipmentZones/'+id);
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 설비구역 등록
 * @param {*} body 
 */
export const postEquipmentZones = async(body)=>{
  //console.log(body);
  await customFileAxios.post('/api/equipmentZones',body);
}

/**
 * 설비구역 수정
 * @param {*} body 
 */
export const patchEquipmentZones = async(id, body)=>{
  //console.log(body);
  await customFileAxios.patch('/api/equipmentZones/'+id, body);
}

/**
 * 설비에 연결된 유지보수 업체 ID로 설비구역 가져오기 - GroupBy 관리주체
 * @param {*} id 
 * @returns 
 */
export const getMaintenanceEquipmentZonesByCompanyId = async(companyId)=>{
  const res = await customAxios.get('/api/equipmentZones/equipments/maintenance/company/'+companyId+':includingLocationMaps');
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 관리주체 ID로 모든 설비구역 가져오기
 * @param {*} id 
 * @returns 
 */
export const getManagementEquipmentZonesByCompanyId = async(companyId)=>{
  const res = await customAxios.get('/api/equipmentZones/management/company/'+companyId+':includingLocationMaps');
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 설비구역이미지에 설비매핑정보 수정
 * @param {*} body 
 */
export const patchEquipmentLocationMapCoordinates = async(id, body)=>{
  //console.log(body);
  await customAxios.patch('/api/equipmentLocationMap/coordinates/'+id, body);
}

/**
 * locationMapId로 설비와 좌표의 매핑목록 반환
 * @param {*} mapId 
 * @returns 
 */
export const getEquipmentLocationMapByMapId = async(mapId)=>{
  const res = await customAxios.get('/api/equipmentLocationMap/'+mapId);
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 활성 상태의 모든 구역 분류 조회
 * @param {*}  
 * @returns 
 */
export const getEquipmentZoneCategories = async()=>{
  const res = await customAxios.get('/api/equipmentZoneCategories');
  if (res.data) {
    return res.data;
  }
  return null;
}


/**
 * 설비구역 상세
 * 2026-04-08
 * @param {*} id 
 * @returns 
 */
export const getEquipmentZoneByCode = async(code)=>{
  const res = await customAxios.get('/api/equipmentZones/code/'+code);
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 설비가 설치되어 있는 구역카테고리 목록과 설비가 설치되어 있는 카테고리 하위의 구역목록
 * 2026-04-08
 * @param {*} id 
 * @returns 
 */
export const getSearchFiltersEquipmentZones = async(query)=>{
  const res = await customAxios.get('/api/search-filters/equipment-zones', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 활성 상태의 모든 구역 분류 조회
 * @param {*}  
 * @returns 
 */
export const getEquipmentZoneCategoriesByManagementCompanyId = async(companyId)=>{
  const res = await customAxios.get(`/api/equipmentZoneCategories/managementCompany/${companyId}`);
  if (res.data) {
    return res.data;
  }
  return null;
}

